import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/interest-rate-period";

export const searchByPage = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getObjById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdateObj = (dto) => axios.post(API_PATH + "/save-or-update", dto);

export const deleteObj = (id) => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllDto = () => axios.get(API_PATH + "/get-all");

export const getByPaymentMethodId = (paymentMethodId) => axios.get(API_PATH + "/get-by-payment-method/" + paymentMethodId);
